export const getBaseDomain = (hostname: string): string => {
  let parts = hostname.split('.');
  while (parts.length > 2) {
    parts.shift();
  }
  return parts.join('.');
}

export const getBasePath = (): string => {
  const pathname = window.location.pathname;
  let parts = pathname.split("/");
  parts.pop();
  return parts.join("/")+"/";
}
